import ReduxReducerSagaController, { IReduxReducerSagaController } from '@core-ui/redux_saga_controller';
import history from 'app/history';
import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

// eslint-disable-next-line import/no-mutable-exports
let controller: IReduxReducerSagaController;

const configureStore = (initialState = {}) => {
  const composeEnhancers = composeWithDevTools({});
  const sagaMiddleware = createSagaMiddleware();
  const reducers = rootReducer(history);

  const store = createStore(
    combineReducers(reducers),
    initialState,
    composeEnhancers(applyMiddleware(sagaMiddleware, routerMiddleware(history))),
  );

  controller = ReduxReducerSagaController(store, reducers, sagaMiddleware);

  controller.injectSaga('root', rootSaga);

  return store;
};

export { controller, configureStore };
